import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopPreSalePanel from "@/entities/analytics/dashboards/TopPreSalePanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useClientWorkbooksStore } from "@/store/catalog_data/client_reports";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreSalePage',
  setup(__props) {

// Используются конкретные id воркбука и дашборда, потому что это страница конкретного дашборда!!! Может не отображаться при перезаливе бд
const authStore = useAuthStore();
const workbooksStore = useClientWorkbooksStore();
const dashboardsFormRef = ref();
const isDashboardSelected = ref(true);

const isDenied = computed(() => {
  const isInhouseUser =
    authStore.getPayloadTenant() === rootGetters.inhouse_tenant;

  if (!isInhouseUser) {
    return true;
  }

  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"]
  );
});

const handleExpandDashboard = () => {
  if (dashboardsFormRef.value) {
    dashboardsFormRef.value.expandDashboard();
  }
};

// Метод для обновления состояния выбранного дашборда
const updateDashboardSelection = (selected: boolean) => {
  isDashboardSelected.value = selected;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopPreSalePanel, {
            "name-dashbords": "Pre-sale",
            "is-dashboard-selected": isDashboardSelected.value,
            onExpandDashboard: handleExpandDashboard
          }, null, 8, ["is-dashboard-selected"]),
          _createVNode(DashboardsViewForm, {
            ref_key: "dashboardsFormRef",
            ref: dashboardsFormRef,
            store: _unref(workbooksStore),
            type: "own_workbook",
            "hide-expand-button": true,
            "default-workbook": 42,
            "default-dashboard": 52,
            onDashboardSelected: updateDashboardSelection
          }, null, 8, ["store"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})